
import {Component, Prop, Vue} from 'vue-property-decorator';
import {CfForm as Cf} from "@/api/priceclass/types";
import {cfDetail, createCf, updateCf} from "@/api/priceclass";
import {ElForm} from 'element-ui/types/form';

@Component({name: "CfForm"})
export default class CfForm extends Vue {
  @Prop(String) readonly pcName: '';
  @Prop(String) readonly pcId: '';

  private showClassNumber = false; // 添加定价系数-弹窗隐显

  private cfForm: Cf = {
    id: null,
    name: null,
    pcId: null,
    value: null,
    status: true,
  };

  private rules = {
    name: [
      {required: true, message: "请填写系数名称", trigger: "change"},
      {
        required: true,
        validator: (rule, value, callback) => {
          if (value.length > 64) {
            callback(new Error("系数名称不能超过64个字符"));
          } else {
            callback();
          }
        },
        trigger: "change"
      }
    ],
    value: [
      {required: true, message: "请填写系数", trigger: 'change'}
    ]
  }


  public async show(row) {
    if (row && row.id) {
      const content: any = await cfDetail(row.id);
      this.cfForm = content;
    } else {
      this.$nextTick(() => {
        (this.$refs['form'] as ElForm).resetFields();
      })
    }
    this.showClassNumber = true;
  }

  private handleConfirm() {
    (this.$refs['form'] as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.cfForm.id)
        if (this.cfForm.id) {
          await updateCf({...this.cfForm, pcId: this.pcId})
        } else {
          await createCf({...this.cfForm, pcId: this.pcId});
        }
        this.showClassNumber = false;
        this.$emit('confirm');
      }
    })
  }
}
